import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ReportIcon from '@mui/icons-material/Report';
import sty from './alert.module.css';
import { useActivePatrolUI } from '../../context/activePatrol/ActivePatrolUIProvider';
import { useActivePatrolData } from '../../context/activePatrol/ActivePatrolDataProvider';

function ActivePatrolWarning() {
	const {
		showActivePatrolWarningModal,
		setShowActivePatrolWarningModal,
		setShowDrawer,
	} = useActivePatrolUI();
	const { activePatrolDataRef } = useActivePatrolData();

	const handleCloseModal = () => {
		setShowActivePatrolWarningModal(false);
	};

	const handleShowActivePatrol = () => {
		setShowActivePatrolWarningModal(false);
		setShowDrawer(true);
	};

	return (
		<Dialog
			open={showActivePatrolWarningModal}
			onClose={handleCloseModal}
			aria-labelledby="draggable-dialog-title"
		>
			<div className={sty.header_bar} />
			<section className={sty.dialog_section}>
				<ReportIcon className={sty.icon} />
				<div className={sty.dialog_title_content}>
					<DialogTitle
						className={sty.dialog_title}
						id="draggable-dialog-title"
					>
						Patrol In Progress
					</DialogTitle>
					<DialogContent className={sty.dialog_content}>
						<DialogContentText>
							You currently have an active patrol session
							{` (${activePatrolDataRef.current?.patrolInfo.cust_name} ${activePatrolDataRef.current?.patrolInfo.address})`}
							. Please complete or exit it before starting a new
							one. How would you like to proceed?
						</DialogContentText>
					</DialogContent>
				</div>
			</section>
			<Divider />
			<DialogActions className={sty.dialog_actions}>
				<Button
					variant="outlined"
					size="medium"
					onClick={handleCloseModal}
					className={sty.action_button}
				>
					Back
				</Button>
				<Button
					variant="contained"
					size="medium"
					onClick={handleShowActivePatrol}
					className={sty.action_button}
				>
					View active patrol
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ActivePatrolWarning;
